// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__zFVxc","wrapper__item":"Pagination_wrapper__item__ho+2t"};